import React, { useState } from "react"
import { Link } from "react-router-dom"
import {
  Carousel,
  CarouselItem,
  CarouselControl,
  CarouselIndicators,
  Container,
} from "reactstrap"
// import homebanner1 from "../../assets/img/home/slider/newbanner-subsaath01.jpg"
import homebanner1 from "../../assets/img/home/slider/SABSAATH BANNER 3.png"
import homebanner2 from "../../assets/img/home/slider/newbanner-subsaath02.jpg"
import ramzanmobile from "../../assets/img/home/slider/ramzanmobile.jpg"
import ramzandesktop from "../../assets/img/home/slider/ramzandesktop.jpg"
import homebanner4 from "../../assets/img/home/slider/Sab-Saath-x-Taskeen-Banner.jpg"
import homebanner3 from "../../assets/img/home/slider/newbanner-subsaath03.jpg"
import homebanner5 from "../../assets/img/home/slider/QurbaniBanner2023.png"
import homebanner6 from "../../assets/img/home/slider/Qurbanibanner2.png"
import p3Banner from "../../assets/img/home/slider/P3 banner.jpg"
// import BargainBasementSaleBanner from "../../assets/img/home/slider/BargainBasementSale.jpg"
import mhomebanner1 from "../../assets/img/home/slider/newbanner-subsaathm01.jpg"
import mhomebanner2 from "../../assets/img/home/slider/newbanner-subsaathm02.jpg"
import mhomebanner3 from "../../assets/img/home/slider/newbanner-subsaathm03.jpg"
import mhomebanner4 from "../../assets/img/home/slider/Sab-Saath-Taskeen-MobileBanner.jpeg"
import mhomebanner5 from "../../assets/img/home/slider/qurbaniBannerMobile2023.jpeg"
import mp3Banner from "../../assets/img/home/slider/P3 banner mobile.jpg"
import winter from "../../assets/img/home/slider/winter.png"
import gaza from "../../assets/img/home/slider/gaza.jpg"
import gazamobile from "../../assets/img/home/slider/gazamobilebanner.jpeg"
import christmas from "../../assets/img/home/slider/banner for Christmas Campaign .png"
import GazaBanner2 from '../../assets/img/home/slider/Gaza banner 2.jpeg'

import GoatSadaqaMobileBanner2 from '../../assets/img/home/slider/GoatSadaqaMobileBanner2.jpeg'
import GoatSadaqa from '../../assets/img/home/slider/Goat Sadaqa.jpeg'
import HissaBanner2Mobile from '../../assets/img/home/slider/HissaBanner2Mobile.png'
import QurbaniBanner2Mobile from '../../assets/img/home/slider/QurbaniBanner2Mobile.png'
import CamelBanner2Mobile from '../../assets/img/home/slider/CamelBanner2Mobile.png'
import GazaBanner2Mobile from '../../assets/img/home/slider/GazaBanner2Mobile.png'

import genericbanner from '../../assets/img/home/slider/generic banner.png'
import Hissa from '../../assets/img/home/slider/Hissa.png'
import QurbaniGoatBanner from '../../assets/img/home/slider/Qurbani goat banner.png'
import MobileGoatQurbani from '../../assets/img/home/slider/mobile goat qurbani.png'
import Qurbanicamelbanner2 from '../../assets/img/home/slider/Qurbani camel banner 2.png'
import WaterBanner from '../../assets/img/home/slider/water banner.png'
import WaterBannerMobile from '../../assets/img/home/slider/water banner (mobile).png'
const items = [
  // {
  //   src: homebanner5,
  //   mobilesrc: mhomebanner5,
  //   link: "/QurbaniCampaign",
  //   key: 5,
  // },
  // {
  //   src: ramzandesktop,
  //   mobilesrc: ramzanmobile,
  //   link: "/ramazancampaign",
  //   key: 3,
  // },
  

  // {
  //   src: genericbanner,
  //   mobilesrc: QurbaniBanner2Mobile,
  //   // src: QurbaniBannerGeneral,
  //   // mobilesrc: QurbaniBanner2Mobile,
  //   link: "/QurbaniCampaign",
  //   key: 3,
  // },
  //  {
  //   src: QurbaniGoatBanner,
  //   mobilesrc: MobileGoatQurbani,
  //   link: "/QurbaniDonate/1313",
  //   key: 4,
  // },
  // {
  //   src: Hissa,
  //   // src: QurbaniBannerCow,
  //   mobilesrc: HissaBanner2Mobile,
  //   link: "/QurbaniDonate/1315",
  //   key: 6,
  // },
  // {
  //   src: Qurbanicamelbanner2,
  //   // src: QurbaniBannerCamel,
  //   mobilesrc: CamelBanner2Mobile,
  //   link: "/QurbaniDonate/120",
  //   key: 9,
  // },
  // {
  //   src: WaterBanner,
  //   mobilesrc: WaterBannerMobile,
  //   link: "/Donation/1742",
  //   // link: "/QurbaniDonate/1730",
  //   key: 55,
  // },
  // {
  //   src: BargainBasementSaleBanner,
  //   mobilesrc: BargainBasementSaleBanner,
  //   link: "/case-detail/12043",
  //   // link: "/QurbaniDonate/1730",
  //   key: 6,
  // },
  {
    src: GazaBanner2,
    mobilesrc: GazaBanner2Mobile,
    link: "/case-detail/9368",
    // link: "/QurbaniDonate/1730",
    key: 5,
  },
  {
    src: GoatSadaqa,
    mobilesrc: GoatSadaqaMobileBanner2,
    link: "/meals-donate/361",
    key: 4,
  },
  // {
  //   src: GazaBanner2,
  //   mobilesrc: GazaBanner2Mobile,
  //   // link: "/case-detail/9368",
  //   link: "/QurbaniDonate/1730",
  //   key: 5,
  // },
  // {
  //   src: gaza,
  //   mobilesrc: gazamobile,
  //   link: "/case-detail/9368",
  //   key: 2,
  // },
  // {
  //   src: christmas,
  //   mobilesrc: christmas,
  //   link: "/christmas",
  //   key: 11,
  // },
  // {
  //   src: homebanner1,
  //   mobilesrc: mhomebanner1,
  //   link: "/about-us#how-we-started",
  //   key: 1,
  // },
  {
    src: homebanner1,
    mobilesrc: mhomebanner1,
    link: "/about-us#how-we-started",
    key: 1,
  },
  // {
  //   src: winter,
  //   mobilesrc: winter,
  //   link: "/meals-donate/1693",
  //   key: 5,
  // },
  // {
  //   src: homebanner3,
  //   mobilesrc: mhomebanner3,
  //   link: "/case-detail/4188",
  //   key: 4,
  // },
  // {
  //   src: p3Banner,
  //   mobilesrc: mp3Banner,
  //   link: "/case-detail/6126",
  //   key: 132,
  // },
  // {
  //   src: homebanner6,
  //   mobilesrc: homebanner6,
  //   link: "/QurbaniCampaign",
  //   key: 6,
  // },
  // {
  //   src: homebanner2,
  //   mobilesrc: mhomebanner2,
  //   link: "/ramazancampaign",
  //   key: 3,
  // },
 
  // {
  //   src: homebanner4,
  //   mobilesrc: mhomebanner4,
  //   link: "/cases-list/3",
  //   key: 3,
  // },
 
]

const extrClass = [6]

function HomeCarousel(args) {
  const [activeIndex, setActiveIndex] = useState(0)
  const [animating, setAnimating] = useState(false)

  const next = () => {
    if (animating) return
    const nextIndex = activeIndex === items?.length - 1 ? 0 : activeIndex + 1
    setActiveIndex(nextIndex)
  }

  const previous = () => {
    if (animating) return
    const nextIndex = activeIndex === 0 ? items?.length - 1 : activeIndex - 1
    setActiveIndex(nextIndex)
  }

  const goToIndex = (newIndex) => {
    if (animating) return
    setActiveIndex(newIndex)
  }

  const slides = items.map((item) => {
    return (
      <CarouselItem
        onExiting={() => setAnimating(true)}
        onExited={() => setAnimating(false)}
        key={item?.key}
        responsive={true}
      >
        <section
          className="section jumbotron jumbotron-fluid"
          
          style={{
            paddingTop: 0,
            paddingBottom: 0,
          }}
        >
          <Link to={item.link}>
            <img className="simg-dasktop" alt="" src={item.src} />
            <img className="simg-mobile" alt="" src={item.mobilesrc} />
          </Link>
        </section>
      </CarouselItem>
    )
  })

  return (
    <Container className="mt-3">
    <Carousel
      activeIndex={activeIndex}
      next={next}
      ride="carousel"
      previous={previous}
      responsive={true}
      autoPlay={false}
      autoPlaySpeed={7500}
      infinite={true}
      swipeable={false}
      draggable={false}
      showDots={false}
      ssr={true} // means to render carousel on server-side.
      // Time difference between auto play transitions in seconds.
      autoPlayInterval={7500}
      interval={7500}
      keyBoardControl={true}
      transitionDuration={500}
      containerClass="carousel-container"
      removeArrowOnDeviceType={["tablet", "mobile"]}
      dotListClass="custom-dot-list-style"
      itemClass="carousel-item-padding-40-px p-3"
      pauseOnHover={true}
      {...args}
    >
      <CarouselIndicators
        items={items}
        activeIndex={activeIndex}
        onClickHandler={goToIndex}
      />
      {slides}
      <CarouselControl
        direction="prev"
        directionText="Previous"
        onClickHandler={previous}
        className="carousel-control-prev-home"
        style={{color:'blue !important'}}
      />
      <CarouselControl
        direction="next"
        directionText="Next"
        onClickHandler={next}
        className="carousel-control-next-home"
        cssModule={{
          "carousel-control-next-icon": "carousel-control-next-icon",
        }}
      />
    </Carousel>
    </Container>
  )
}

export default HomeCarousel
